import { AlertCircle } from 'lucide-react';

import { useT } from '../../../i18n';
import type { ApiError, LoiTruong } from '../../../lib/errors';
import { useLoi } from '../../../hooks/useLoi';
import { MA_LOI_NOP_GOI } from '../constants';
import type { MaLoiNopGoi } from '../types';

function laMaLoiNopGoi(ma: string | undefined): ma is MaLoiNopGoi {
  return Boolean(ma && ma in MA_LOI_NOP_GOI);
}

/**
 * Lỗi của lần nộp gói vừa rồi (`POST /api/v1/vendor/modules`, ADR-0045 mục 2).
 * Mã `MODULE_*` dịch qua `MA_LOI_NOP_GOI`; mảng `errors` của `MODULE_MANIFEST_INVALID`
 * liệt kê từng vi phạm theo `pointer`. Mã khác (hết phiên, mất mạng…) qua `useLoi()`
 * như mọi nơi khác trong kho.
 */
export function LoiNopGoi({ loi }: { loi: unknown }) {
  const { t } = useT();
  const dichLoi = useLoi();
  const err = loi as ApiError;
  const viPham = laMaLoiNopGoi(err?.code) && Array.isArray(err.details) ? (err.details as LoiTruong[]) : [];

  return (
    <div role="alert" className="flex items-start gap-2 rounded border border-danger-200 bg-danger-50 px-3 py-2.5">
      <AlertCircle size={15} className="mt-0.5 shrink-0 text-danger-600" />
      <div className="min-w-0 text-xs leading-relaxed text-danger-700">
        <p className="font-medium">
          {laMaLoiNopGoi(err?.code) ? t(MA_LOI_NOP_GOI[err.code as MaLoiNopGoi]) : dichLoi(loi)}
        </p>
        {viPham.length > 0 && (
          <ul className="mt-1 list-disc space-y-0.5 pl-4">
            {viPham.map((vp, i) => (
              <li key={vp.pointer ?? i}>
                {vp.pointer && <span className="font-mono">{vp.pointer}</span>}
                {vp.pointer && ' — '}
                {vp.detail}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
